import type { RouteRecordRaw } from 'vue-router';

export const ITEMS_INQUIRY_ROUTER: RouteRecordRaw[] = [
  {
    path: '/sales/items-inquiry',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/sales/items-inquiry/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/sales/itemsInquiry/views/List.vue'),
        name: 'Items Inquiry List',
        meta: {
          title: '아이템별 매출조회',
        },
      },
    ],
  },
];
